<template>
    <div class="goods-container">
        <div class="goods-header">
            <h1 class="goods-type">{{ goodsType }}</h1>
        </div>
        <div class="goods-body">
            <div class="goods-item" v-for="goods in goodsList" :key="goods.id">
                <h2 class="goods-title">{{ goods.name }}</h2>
                <div class="goods-quota">
                    每月{{ (goods.flow_quota / 10000).toFixed(2) }}万字额度
                </div>
                <div class="goods-skus">
                    <el-radio-group v-model="selectedSkuCode">
                        <el-radio :label="sku.code" v-for="sku in goods.skus" :key="sku.code">
                            ￥{{ (sku.price / 100).toFixed(2) }} {{ sku.name }}
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="goods-buy">
                    <el-button type="primary" @click="showConfirm(goods)">
                        购买
                    </el-button>
                </div>
            </div>
        </div>
        <el-dialog title="订单确认" :visible.sync="confirmVisible" :show-close="false" :close-on-click-modal="false"
            :center="true" custom-class="confirmBox">
            <p>商品名称：{{ confirmOrder.title }}</p>
            <p>说明：{{ confirmOrder.description }}</p>
            <p>sku名称：{{ confirmOrder.skuName }}</p>
            <p>价格：￥{{ (confirmOrder.price / 100).toFixed(2) }}</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmBuy">支付宝付款</el-button>
            </div>
        </el-dialog>
        <!-- <el-dialog title="公众号下单" :visible.sync="confirmVisible" :show-close="false" :close-on-click-modal="false"
            :center="true" custom-class="confirmBox">
            <p>非常抱歉！！ 由于网站支付流程出现异常，请前往公众号进行下单！</p>
            <p>公众号下单购买的ApiKey，可以直接绑定到账户上，转换成账户套餐！</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取消</el-button>
                <el-button type="primary" @click="redirectGZH">查看公众号下单流程</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>
  
<script>
import { OrderAPI } from '../api/order';
import { PlanAPI } from "../api/plan";

export default {
    name: "Plans",
    data() {
        return {
            goodsType: "GPT3.5",
            goodsList: [],
            confirmVisible: false,
            confirmOrder: {
                title: "",
                description: "",
                skuName: "",
                price: 0,
            },

            selectedSkuCode: "",
            queryPlansParams: {
                flow_type: "gpt3",
                sku_type: 0,
            },
        };
    },
    mounted() {
        this.getGoodsList();
    },
    methods: {
        // 获取商品列表
        getGoodsList() {
            PlanAPI.queryPlans(this.queryPlansParams)
                .then((res) => {
                    this.goodsList = res;
                })
        },
        // 显示确认购买弹框
        showConfirm(goods) {
            const sku = goods.skus.find((sku) => sku.code === this.selectedSkuCode);
            if (!this.$store.state.isLogin) {
                this.$message.warning("请先登录再进行购买")
                return
            }
            if (sku == null) {
                this.$message.warning("请选择该套餐的商品");
                return;
            }
            this.confirmOrder = {
                title: goods.name,
                description: goods.description,
                skuName: sku.name,
                price: sku.price,
            };
            this.confirmVisible = true;
        },
        // 确认购买
        confirmBuy() {
            // TODO: 提交订单
            this.generalOrder()
            this.confirmVisible = false;
        },
        // 提交订单
        generalOrder() {
            OrderAPI.generalOrder(this.selectedSkuCode, null).then(res => {
                // 提交订单成功后，直接触发跳转到支付页面
                OrderAPI.prepayOrder(res.order_no).then(res => {
                    this.openNewTab(res.pay_html)
                    this.$router.replace('/order/' + res.order_no);
                })
            })
        },
        openNewTab(htmlText) {
            // 创建一个新的窗口
            const newWindow = window.open();

            // 给新窗口设置HTML内容
            newWindow.document.write(`
                <html>
                <body>
                    ${htmlText}
                </body>
                </html>
            `);
        },
        // 跳转公众号下单
        redirectGZH(){
          window.open('https://mp.weixin.qq.com/s/77pLwes_S0E_HHpUolmH6w', '_blank');
        }
    },
};
</script>

<style scoped>
.goods-container {
  background-color: #fff;
  padding: 10px;
}

.goods-header {
  display: flex;
  justify-content: center;
}

.goods-type {
  color: #639;
  font-size: 1.2rem;
  font-weight: bold;
}

.goods-body {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.goods-item {
    margin:20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.goods-title {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
}

.goods-quota {
  margin: 15px 0;
  font-size: 0.8rem;
  color: #999;
}

.goods-skus {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.goods-buy {
  text-align: center;
  margin-top: 10px;
}

.el-dialog {
  width: 80%;
  max-width: 400px;
}

.el-dialog__body {
  padding: 20px;
}

.el-dialog__footer {
  padding: 10px 20px;
  text-align: right;
}

.el-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.el-radio {
  margin-bottom: 10px;
}

.el-radio__label {
  font-size: 0.8rem;
}

.confirmBox {
  width: 100%;
}

@media screen and (max-width: 767px) {
  .goods-container>>>.confirmBox {
    width: 90%;
  }
  
  .goods-item {
    flex-basis: 100%;
    margin: 10px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Plans.vue